import { defineStyleConfig } from '@chakra-ui/react'

export const customColors = defineStyleConfig({
     colors: {
      card: {
         10: "#8B8B8B",
         20: "#4A4A4A",
         30: "#212526",
         40: "#313C4E"
      },
      brand: {
        100:"#FE9901",
        200:"#F5F5F5"
        
      },
          primary: {
            500: "#FFA500",
            600: "#FF8C00",
            // ...add more color shades as needed
          },
          buttons:{
            10: '#3B3B3B',
            20: '#F05A00',
          },
          
    },
  })